import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
  userSelectCustomerOpenOptionsChart:
    "userSelectCustomerOpenOptionsChart [Action]",
  userSelectCustomerOpenOptionsChartLoading:
    "userSelectCustomerOpenOptionsChartLoading [Action]",
  userSelectCustomerOpenOptionsChartAsync:
    "userSelectCustomerOpenOptionsChartAsync [Action]",
};
const inistiaState = {
  data: [],
  loading: false,
  total: 0,
};

export const user_select_customer_open_options_chart_Reducer = (
  state = inistiaState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.userSelectCustomerOpenOptionsChart:
      return {
        ...state,
        data: payload?.results,
        total: payload?.total,
      };
    case actionTypes.userSelectCustomerOpenOptionsChartLoading:
      return {
        ...state,
        loading: payload,
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({
    type: actionTypes.userSelectCustomerOpenOptionsChartLoading,
    payload: true,
  });

  let config = {
    url: "select_request",
  };

  let data = {
    table: "marketer",
    method_type: "user_select_marketer_customers_open_options_chart",
    data: payload?.data ? payload.data : {},
    size: 10,
    from_: 0,
  };

  try {
    let res = yield AxiosCustom(config, data);
    let isOk = handleNotificationAlertTrySelect(res);
    if (!isOk) {
      return;
    }
    yield put({
      type: actionTypes.userSelectCustomerOpenOptionsChart,
      payload: res?.data?.response?.data,
    });
  } catch {
    handleNotificationAlertCatch();
  } finally {
    yield put({
      type: actionTypes.userSelectCustomerOpenOptionsChartLoading,
      payload: false,
    });
  }
}

export function* userSelectCustomerOpenOptionsChart() {
  yield takeLatest(
    actionTypes.userSelectCustomerOpenOptionsChartAsync,
    handleWorker
  );
}
